export default "__VITE_ASSET__Clw4TsKj__"